import ComponentLister from './lister.js';

export default class ComplexLister extends ComponentLister {
  constructor(
      prefix = 'complex',
      sComponentMethod = 'ComplexList::onGetJSONData',
      storeList = { active: null }
    ) {
    super(prefix, sComponentMethod, storeList);
    this.obItemBindCallback = function bindComplexItem (item) {
      return {
          img: item.hasOwnProperty('attachOne|preview_image') ? item['attachOne|preview_image'].path : null,
          logo: item.hasOwnProperty('attachOne|logo') ? item['attachOne|logo'].path : null,
          title: item.name,
          subtitle: item.preview_text
      };
    }
  }
}
